export default "__VITE_ASSET__Chx9kKOf__"